exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rating-container.inline{display:inline-flex;margin-left:5px;margin-right:1px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-rewriter.js?{"id":"data-v-29567d46","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/raters/font-awesome/FaBaseGlyph.vue
// module id = 35
// module chunks = 0